import React, { useState, useEffect } from 'react';
import './CrosswordMode.css';
import logger from '../utils/logger';

export type Mode = 'user' | 'withErrors' | 'reveal';

interface CrosswordModeProps {
    onModeSelect: (mode: Mode) => void;
}

const CrosswordMode: React.FC<CrosswordModeProps> = ({ onModeSelect }) => {
    // Initialize selectedMode from localStorage or default to 'user' if not found
    const [selectedMode, setSelectedMode] = useState<Mode>(() => {
        try {
            const storedMode = localStorage.getItem('crosswordSelectedMode');
            return storedMode !== null ? storedMode as Mode : 'user';
        } catch (e) {
            logger.error("Error reading mode from localStorage:", e);
            return 'user';
        }
    });

    // Update localStorage when selectedMode changes
    useEffect(() => {
        try {
            localStorage.setItem('crosswordSelectedMode', selectedMode);
        } catch (e) {
            logger.error("Error storing mode in localStorage:", e);
        }
    }, [selectedMode]);

    const handleModeSelect = (mode: Mode) => {
        setSelectedMode(mode);
        onModeSelect(mode);
    };

    return (
        <div className="mode-selector">
            <button 
                className={`mode-button ${selectedMode === 'user' ? 'selected' : ''}`}
                onClick={() => handleModeSelect('user')}
            >
                User Input Only
            </button>
            <button 
                className={`mode-button ${selectedMode === 'withErrors' ? 'selected' : ''}`}
                onClick={() => handleModeSelect('withErrors')}
            >
                Flag&nbsp;Errors
            </button>
            <button 
                className={`mode-button ${selectedMode === 'reveal' ? 'selected' : ''}`}
                onClick={() => handleModeSelect('reveal')}
            >
                Reveal&nbsp;All
            </button>
        </div>
    );
};

export default CrosswordMode;